module.exports = __webpack_public_path__ + "static/media/close-icon.5d131e01.svg";